@if (loadingTags) {
  <ebs-spinner [spinnerMessage]="'loading tags'"></ebs-spinner>
}

@if (!loadingTags) {
  <div>
    <div class="tag-container" style="border-radius:6px">
      <div class="form-control" style="border: none;">
        <h4 style="margin-bottom: 0;">{{taglistHeader}} </h4>
        @for (tag of tagList; track tag) {
<div (click)="toggleActive(tag)" class="mr-2 mt-3 btn btn-light tag" [ngClass]="{
          'btn-success' : tag.selected, 
          'btn-light' : !tag.selected }">
            @if (!tag.selected) {
              <i class="fal fa-fw fa-tag"></i>
              }@if (tag.selected) {
              <i class="fas fa-fw fa-tag"></i>
              } {{tag.name}}
            </div>
          }
        </div>
      </div>
      @if (tagList.length === 0 && !showError) {
        <p class="text-warning p-2">No tags have yet been added for this course.
        </p>
      }
      <div class="row">
        <div class="col-12">
          @if (canAddTag) {
            <div class="mt-2" style="border-radius:6px;">
              <div class="input-group pt-2 pr-2 pl-2 mb-3">
                <input type="text" [(ngModel)]="tagValue" class="form-control" placeholder="type new tag here"
                  aria-label="single or multiple words" aria-describedby="input-tag" maxlength="tagCharacterLimit">
                <div class="input-group-append" (click)="addTag(tagValue); $event.preventDefault()" style="cursor: pointer;">
                  @if (tagValue && !(tagValue.length > tagCharacterLimit)) {
                    <span class="input-group-text btn btn-primary ml-2" id="input-tag"
                    >Add Tag</span>
                  }
                </div>
              </div>
              @if (tagExists) {
                <p class="text-warning">{{duplicateMessage}}</p>
              }
              @if (tagValue && (tagValue.length > tagCharacterLimit)) {
                <p class="text-warning">Tags must be {{tagCharacterLimit}} characters or less</p>
              }
            </div>
          }
          <div>
            @if (showError) {
              <ebs-message-simple [displayMessage]="errorMessage"></ebs-message-simple>
            }
          </div>
        </div>
      </div>
    </div>
  }